import React from 'react'
import Navbar from '../../layouts/Navbar';
import Sidebar from '../../layouts/Sidebar';

const AdvanceSalary = () => {

  return (
    <div className="container-scroller">
      <Navbar />
      <div className="container-fluid page-body-wrapper d-flex">
        <Sidebar />
        <div className="main-panel flex-grow-1"
          style={{
            padding: "2rem",
            fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
            minHeight: "100vh",
          }}>
           
        </div>
      </div>
    </div>
  );
};


export default AdvanceSalary
